import React, { useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
export default function BookingInquirySection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    if (window.location.hash === "#quote-form") {
      const el = document.getElementById("quote-form");
      if (el) {
        el.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }, []);
  return <section id="quote-form" className="py-20 md:py-28 bg-background text-foreground relative overflow-hidden !bg-[url(https://simprotile.com/wp-content/uploads/2026/03/bathroom_refurbishment_display-1.webp)]">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 ease-out-back transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="text-card-foreground flex flex-col gap-6 py-8 md:py-12 border-2 border-primary/20 shadow-2xl rounded-sm overflow-hidden bg-primary/10 bg-blend-overlay bg-cover bg-center bg-no-repeat !bg-[url(https://simprotile.com/wp-content/uploads/2026/03/luxury_bathroom_tiling_macro.webp)] !bg-[url(https://simprotile.com/wp-content/uploads/2026/03/cropped-image_o8g5vaye.jpg)]">
            <CardHeader className="text-center pb-4 pt-10 px-6 md:px-10">
              <CardTitle className="text-4xl font-serif font-bold mb-4 tracking-tight !text-[hsl(0,0%,0%)] !bg-[hsl(210,14%,89%)] !rounded-xl !opacity-[1] md:text-5xl">
                Get a Professional Quote
              </CardTitle>
              <CardDescription className="text-muted-foreground text-lg font-sans max-w-2xl mx-auto leading-relaxed !text-[hsl(222,47%,11%)] !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] !bg-[hsl(210,14%,89%)] !rounded-3xl md:text-xl">
                Precision craftsmanship for your London home. Share your project requirements with our specialist tiling team for a bespoke estimate.
              </CardDescription>
            </CardHeader>
            
            <div className="px-6 md:px-10 pb-10 pt-2">
              <div className="text-center">
                <Link to="https://simprotile.com/get-a-quote-2/" className="bg-black text-white px-6 py-3 inline-block">
                  Get Your Free Quote
                </Link>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}